export const PULLINSPECTIONAPIDATA = "PULLINSPECTIONAPIDATA";
export const HANDELCHECK = "HANDELCHECK";
export const HANDELCLOSE = "HANDELCLOSE";